import { render, staticRenderFns } from "./ActPedItemsGrid.vue?vue&type=template&id=1b006ad8&scoped=true&"
import script from "./ActPedItemsGrid.vue?vue&type=script&lang=js&"
export * from "./ActPedItemsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b006ad8",
  null
  
)

export default component.exports